import {Modes} from '../modes.js';

const getTotalCellsCount = (cells) => {    
    return cells.length * cells[0].length;
}

const getColoredCells = (cells, color) => {
    let count = 0;
    for(let i = 0; i < cells.length; i++) {
        for(let j = 0; j < cells[i].length; j++) {        
            if(cells[i][j] === color) {            
                count++;
            }
        }
    }
    return count;
}

const Statistic = ({cells}) => {
    const totalCount = cells ? getTotalCellsCount(cells) : 0;
    const COMFORTABLEENVIRONMENTCellsCount = cells ? getColoredCells(cells, Modes.COMFORTABLEENVIRONMENT.color): 0;
    const COMFORTABLEENVIRONMENTCellsPercent= totalCount && (Math.round((COMFORTABLEENVIRONMENTCellsCount/totalCount*100)*10))/10;    
    const AGRESSIVEFIELDCellsCount = cells ? getColoredCells(cells, Modes.AGRESSIVEFIELD.color): 0;
    const AGRESSIVEFIELDCellsPercent= totalCount && (Math.round((AGRESSIVEFIELDCellsCount/totalCount*100)*10))/10;   
    const HOMOGENEOUSFIELDCellsCount = cells ? getColoredCells(cells, Modes.HOMOGENEOUSFIELD.color): 0;
    const HOMOGENEOUSFIELDCellsPercent= totalCount && (Math.round((HOMOGENEOUSFIELDCellsCount/totalCount*100)*10))/10;   
    const VISUALNOISECellsCount = cells ? getColoredCells(cells, Modes.VISUALNOISE.color): 0;
    const VISUALNOISECellsPercent= totalCount && (Math.round((VISUALNOISECellsCount/totalCount*100)*10))/10;   
    const sum = Math.round(HOMOGENEOUSFIELDCellsPercent + VISUALNOISECellsPercent + AGRESSIVEFIELDCellsPercent + COMFORTABLEENVIRONMENTCellsPercent);
    return (        
      <div>
        <table>
            <tbody>
                <tr>
                    <th>Категория</th>
                     <th>Количество</th>
                     <th>%</th>
                </tr>
                <tr>
                    <td>{Modes.COMFORTABLEENVIRONMENT.text}</td>
                    <td>{COMFORTABLEENVIRONMENTCellsCount}</td>
                    <td>{COMFORTABLEENVIRONMENTCellsPercent}%</td>
                </tr>
                <tr>
                    <td>{Modes.AGRESSIVEFIELD.text}</td>
                    <td>{AGRESSIVEFIELDCellsCount}</td>
                    <td>{AGRESSIVEFIELDCellsPercent}%</td>
                </tr>
                <tr>
                    <td>{Modes.HOMOGENEOUSFIELD.text}</td>
                    <td>{HOMOGENEOUSFIELDCellsCount}</td>
                    <td>{HOMOGENEOUSFIELDCellsPercent}%</td>
                </tr>
                <tr>
                    <td>{Modes.VISUALNOISE.text}</td>
                    <td>{VISUALNOISECellsCount}</td>
                    <td>{VISUALNOISECellsPercent}%</td>
                </tr>
                <tr>
                    <td>Выбрано</td>
                    <td>{COMFORTABLEENVIRONMENTCellsCount + AGRESSIVEFIELDCellsCount + HOMOGENEOUSFIELDCellsCount + VISUALNOISECellsCount}</td>
                    <td>{sum}%</td>
                </tr>
                <tr>
                    <td>Итого</td>
                    <td>{totalCount}</td>     
                    <td> </td>               
                </tr>
            </tbody>
        </table>
      </div>  
    );
}

export {Statistic};